import '../styles/main.scss';

// Global packages and imports
import './integration/font-awesome';

// Returns a function, that, as long as it continues to be invoked, will not be triggered.
// The function will be called after it stops being called for `delay` milliseconds.
// https://codeburst.io/throttling-and-debouncing-in-javascript-b01cad5c8edf
export const debounce = (func, delay) => {
    let inDebounce;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(() => func.apply(context, args), delay);
    }
}



// 100vh hack for mobile with hiding address bar
const setVH = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
}
window.addEventListener('resize', debounce(setVH, 50));
setVH();
